(function () {
    const BLOCK_CLASS = 'main-product__details';
    let quantityInputs = [];
    let handleChange = null;
    
    const locale = window.myProductData.locale || 'en';
    const country = window.myProductData.country || 'DE';

    function getCurrencyTitle() {
      switch(true) {
        case country === 'CH':
          return 'CHF ';
        case country === 'US':
          return '$';
        case window.myProductData.currency:
          return window.myProductData.currency;
        default:
          return '€';
      }
    }

    function costPerKilogram(priceCents, grams, discountPercentage = 0) {
      const discountedCents = Math.ceil(priceCents * (1 - discountPercentage / 100));
      
      const multiplier = 1000 / grams;
      const pricePerKgCents = Math.ceil(discountedCents * multiplier);
    
      return pricePerKgCents / 100;
    }

    function updatePricePerKg(discount, weight, priceCents) {
      const productPriceMeasurementEl = document.querySelector('.product-unit-price__measurment span');
      const unitPriceCents = priceCents || window.myProductData?.price || 0;

      console.log('updatePricePerKg', discount, weight, priceCents)
    
      if (productPriceMeasurementEl && unitPriceCents && weight > 0) {
        const pricePerKg = costPerKilogram(unitPriceCents, weight, discount);

        const roundedPricePerKg = bankersRound(pricePerKg);
        const formattedPricePerKg = formatNumberLocale(roundedPricePerKg);
        
        productPriceMeasurementEl.textContent = `${getCurrencyTitle()}${formattedPricePerKg}`;
      }
    }

    function bankersRound(value, decimals = 2) {
      const factor = Math.pow(10, decimals);
      const n = value * factor;
      const rounded = (Math.round(n) % 2 === 0) ? Math.round(n) : Math.floor(n + 0.5);
      
      return (rounded / factor).toFixed(decimals);
    }
    
    function formatNumberLocale(value) {
      const decimalSeparator = locale === 'de' ? ',' : '.';
      const thousandSeparator = locale === 'de' ? '.' : ',';
      
      let [integerPart, fractionPart] = value.split('.');
      
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
      
      if (fractionPart) {
        return integerPart + decimalSeparator + fractionPart;
      } else {
        return integerPart;
      }
    }
  
    function updatePrice(quantity) {
      const fullPriceEl = document.querySelector('.full-selected-price');
      const priceEl = document.querySelector('.product-price_top .price');
      const selectedInput = document.querySelector('input[name="quantity-box"]:checked');
      const compareAtPrice = window.myProductData?.compare_at_price;
      
      const unitPriceCents = window.myProductData?.price || 0;
      const unitPrice = unitPriceCents / 100;
      const unitCompareAtPriceCents = compareAtPrice || 0;
      const unitCompareAtPrice = unitCompareAtPriceCents / 100;

      let discount = 0;
      
      if (selectedInput && selectedInput.hasAttribute('data-discount-percentage')) {
        discount = parseFloat(selectedInput.getAttribute('data-discount-percentage') || 0);
      }

      let discountedUnitPriceCents = unitPriceCents;
      
      if (discount > 0) {
        const discountedFloat = unitPriceCents * (1 - discount / 100);
        discountedUnitPriceCents = Math.ceil(discountedFloat);
      }
      
      const totalPriceCents = discountedUnitPriceCents * quantity;
    
      // Convert back to euros
      const totalPrice = (totalPriceCents / 100);
      
      if (fullPriceEl && unitPrice) {
        const roundedTotalPrice = bankersRound(totalPrice);
        const formattedTotalPrice = formatNumberLocale(roundedTotalPrice);
        priceEl.textContent = `${getCurrencyTitle()}${formattedTotalPrice}`;
        getDiscountValue();
        updateRechargeWidgetVisualPrice(formattedTotalPrice, formattedTotalPrice, quantity);

        if (window.myProductData?.useCustomPrices) {
          const customPriceStr = window.myProductData?.customComparePrices[quantity - 1] || '0';
          const customPriceNum = parseFloat(customPriceStr.replace(',', '.'));
          const fullPrice = bankersRound(customPriceNum);
          const formattedCustomPrice = formatNumberLocale(fullPrice);
          fullPriceEl.textContent = `${getCurrencyTitle()}${formattedCustomPrice}`;
          updateRechargeWidgetVisualPrice(formattedCustomPrice, formattedTotalPrice, quantity);
          // Original price must always be shown even though there is no quantity selector
        } else if (quantity == 1 && !!compareAtPrice) {
            const fullPrice = bankersRound(unitCompareAtPrice);
            fullPriceEl.textContent = `${getCurrencyTitle()}${formatNumberLocale(fullPrice)}`;
            updateRechargeWidgetVisualPrice(formatNumberLocale(fullPrice), formattedTotalPrice, quantity);
        } else {
          if (quantity < 2) {
            const pricePerItem = document.querySelector('.main-product__price__wrapper .product-price_top').dataset.pricePerItem;
            const value = pricePerItem / 100;
            const price = bankersRound(value);
            const formattedPrice = formatNumberLocale(price);

            fullPriceEl.textContent = `${getCurrencyTitle()}${formattedPrice}`;
            updateRechargeWidgetVisualPrice(formattedTotalPrice, formattedTotalPrice, quantity);
          } else {
            const fullPrice = bankersRound(unitPrice * quantity);
            fullPriceEl.textContent = `${getCurrencyTitle()}${formatNumberLocale(fullPrice)}`;
            updateRechargeWidgetVisualPrice(formatNumberLocale(fullPrice), formattedTotalPrice, quantity);
          }
        }
      }

      if (priceEl && quantity > 1) {
        priceEl.classList.add('discounted');
      } else {
        priceEl.classList.remove('discounted');
      }
    }

    function observeRechargeMainStyles() {
      const widget = document.querySelector("recharge-subscription-widget");
      if (!widget || !widget.shadowRoot) return;

      // Function to inject main styles
      function injectMainStyles() {
        if (widget.shadowRoot.querySelector("#custom-recharge-styles")) return;
        const style = document.createElement("style");
        style.id = "custom-recharge-styles";
        style.textContent = `
          .rc-purchase-option__label {
            display: flex !important;
            flex-direction: row !important;
            align-items: center !important;
            justify-content: space-between !important;
          }
          .rc-purchase-option__selector,
          rc-benefits {
            font-weight: 400 !important;
          }
          .rc-purchase-option__prices {
            text-align: right !important;
            margin-left: 1em !important;
          }
          .rc-price.strike-through {
            margin-right: 5px;
          }
        `;
        widget.shadowRoot.appendChild(style);
      }

      function updatePriceBySubscription() {
        if (!widget.shadowRoot.querySelector('.rc-purchase-option__subscription rc-radio-icon') 
          || !widget.shadowRoot.querySelector('.rc-purchase-option__subscription .rc-price.strike-through + .rc-price')
        ) return

        getDiscountValue();

        const isChecked = widget.shadowRoot.querySelector('.rc-purchase-option__subscription rc-radio-icon').hasAttribute('checked');

        if (!isChecked) return

        const checkedInputValue = document.querySelector('input[name="quantity-box"]:checked')?.value;

        if (checkedInputValue === "1") {
          const fullPriceEl = document.querySelector('.full-selected-price');
          const pricePerItem = document.querySelector('.main-product__price__wrapper .product-price_top').dataset.pricePerItem;
          const value = pricePerItem / 100;
          const price = bankersRound(value);
          const formattedPrice = formatNumberLocale(price);

          fullPriceEl.textContent = `${getCurrencyTitle()}${formattedPrice}`;
        }
            
        // Change price
        const priceEl = document.querySelector('.product-price_top .price');
        const priceNewEl = widget.shadowRoot.querySelector('.rc-purchase-option__subscription .rc-price.strike-through + .rc-price');
        const price = priceNewEl.innerText.match(/€\s*\d+,\d+/)[0];

        priceEl.textContent = price;

        //Change price per kg
        const block = document.querySelector(`.${BLOCK_CLASS}`);

        let defaultProductWeight;
        let defaultQuantity = window.myProductData.default_selected_quantity;

        if (block.querySelector('input[name="quantity-box"]:checked')?.getAttribute('data-product-weight')) {
          defaultProductWeight = parseInt(
            block.querySelector('input[name="quantity-box"]:checked')?.getAttribute('data-product-weight') || '1',
            10
          );
          defaultQuantity = parseInt(
            block.querySelector('input[name="quantity-box"]:checked')?.value || '1',
            10
          );
        } else {
          defaultProductWeight = window.myProductData.variants[0].unit_price_measurement.quantity_value;
        }
        
        const cents = Math.round(
          (parseFloat(price.replace("€", "").trim().replace(",", ".") ) * 100) / defaultQuantity
        );

        updatePricePerKg(0, defaultProductWeight, cents)
      }

      // Inject initially
      injectMainStyles();
      updatePriceBySubscription();

      // Observe for re-renders inside widget ShadowRoot
      const observer = new MutationObserver(() => {
        injectMainStyles();
        updatePriceBySubscription();
      });

      observer.observe(widget.shadowRoot, { childList: true, subtree: true });
    }

    function observeRechargeBenefitsStyles() {
      const widget = document.querySelector("recharge-subscription-widget");
      if (!widget || !widget.shadowRoot) return;

      function injectBenefitsStyles() {
        const benefits = widget.shadowRoot.querySelector("rc-benefits");
        if (!benefits || !benefits.shadowRoot) return;
        if (benefits.shadowRoot.querySelector("#custom-benefits-styles")) return;

        const style = document.createElement("style");
        style.id = "custom-benefits-styles";
        style.textContent = `
          .rc-benefits__list p {
            margin-top: 0 !important;
          }
        `;
        benefits.shadowRoot.appendChild(style);
      }

      // Inject initially
      injectBenefitsStyles();

      // Observe for re-renders inside rc-benefits ShadowRoot
      const observer = new MutationObserver(() => {
        injectBenefitsStyles();
      });

      // Observe the main widget first, because rc-benefits may be replaced on re-render
      observer.observe(widget.shadowRoot, { childList: true, subtree: true });
    }

    function observeRechargeOneTimePurchaseStyles() {
      const widget = document.querySelector("recharge-subscription-widget");
      if (!widget || !widget.shadowRoot) return;

      function injectOneTimeStyles() {
        const oneTime = widget.shadowRoot.querySelector("rc-onetime-drawbacks");
        if (!oneTime || !oneTime.shadowRoot) return;
        if (oneTime.shadowRoot.querySelector("#custom-onetime-styles")) return;

        const style = document.createElement("style");
        style.id = "custom-onetime-styles";
        style.textContent = `
          .rc-benefits__list p {
            margin-top: 0 !important;
            font-weight: 400 !important;
          }
        `;
        oneTime.shadowRoot.appendChild(style);
      }

      function updatePriceBySubscription() {
        if (!widget.shadowRoot.querySelector('.rc-selection__onetime rc-radio-icon') 
          || !widget.shadowRoot.querySelector('.rc-selection__onetime .rc-price')
        ) return

        const isChecked = widget.shadowRoot.querySelector('.rc-selection__onetime rc-radio-icon').hasAttribute('checked');
        const priceOptionEl = widget.shadowRoot.querySelector('.rc-selection__onetime .rc-purchase-option__prices');

        if (priceOptionEl && priceOptionEl.dataset.updated !== 'true') {
          const span = document.createElement('span');
          span.className = 'strike-through text-muted';

          priceOptionEl.prepend(span);
          priceOptionEl.dataset.updated = 'true';
        }

        if (!isChecked) return

        const checkedInputValue = document.querySelector('input[name="quantity-box"]:checked')?.value;
        const fullPriceEl = document.querySelector('.full-selected-price');

        if (checkedInputValue === "1") {
          fullPriceEl.textContent = '';
        }

        // Change price
        const priceEl = document.querySelector('.product-price_top .price');
        const priceNewEl = widget.shadowRoot.querySelector('.rc-selection__onetime .rc-price');
        const price = priceNewEl.innerText.match(/€\s*\d+,\d+/)[0];

        priceEl.textContent = price;
        
        //Change price per kg
        const block = document.querySelector(`.${BLOCK_CLASS}`);
        
        let defaultProductWeight;
        let defaultQuantity = window.myProductData.default_selected_quantity;

        if (block.querySelector('input[name="quantity-box"]:checked')?.getAttribute('data-product-weight')) {
          defaultProductWeight = parseInt(
            block.querySelector('input[name="quantity-box"]:checked')?.getAttribute('data-product-weight') || '1',
            10
          );
          defaultQuantity = parseInt(
            block.querySelector('input[name="quantity-box"]:checked')?.value || '1',
            10
          );
        } else {
          defaultProductWeight = window.myProductData.variants[0].unit_price_measurement.quantity_value;
        }

        const cents = Math.round(
          (parseFloat(price.replace("€", "").trim().replace(",", ".") ) * 100) / defaultQuantity
        );

        updatePricePerKg(0, defaultProductWeight, cents)
      }

      // Inject initially
      injectOneTimeStyles();
      updatePriceBySubscription();

      // Observe for re-renders inside rc-onetime-drawbacks ShadowRoot
      const observer = new MutationObserver(() => {
        injectOneTimeStyles();
        updatePriceBySubscription();
      });

      // Observe the main widget first, because rc-onetime-drawbacks may be replaced on re-render
      observer.observe(widget.shadowRoot, { childList: true, subtree: true });
    }

    // --- 🔥 Dynamically detect Recharge subscription discount ---
    let discountPercent = 20;

    function getDiscountValue() {
      const widget = document.querySelector('recharge-subscription-widget');
      if (!widget?.shadowRoot) return;

      const radio = widget.shadowRoot.querySelector('.rc-purchase-option__subscription rc-radio-icon');

      const isChecked = radio?.hasAttribute('checked');

      if (!isChecked) return

      const benefits = widget.shadowRoot.querySelector('rc-benefits');
      const shadow2 = benefits.shadowRoot;
      const benefitsList = shadow2.querySelector('.rc-benefits__list');

      if (!radio || !benefits || !shadow2 || !benefitsList) return;

      const text = benefitsList.textContent.trim();
      const match = text.match(/(\d+(?:[\.,]\d+)?)%/);
      if (match) {
        discountPercent = parseFloat(match[1].replace(',', '.'));
      }

      // As a fallback, look for any element mentioning a % discount
      if (!discountPercent) {
        const allTexts = Array.from(shadow.querySelectorAll('p, span')).map(el => el.textContent);
        for (const t of allTexts) {
          const match = t.match(/(\d+(?:[\.,]\d+)?)%/);
          if (match) {
            discountPercent = parseFloat(match[1].replace(',', '.'));
            break;
          }
        }
      }

      // Fallback to a default if nothing found
      if (!discountPercent) discountPercent = 20;
    }


function updateRechargeWidgetVisualPrice(oldPrice, oneTimePrice, quantity) {
      const widget = document.querySelector('recharge-subscription-widget');
      if (!widget?.shadowRoot) return;

      const shadow = widget.shadowRoot;
      const priceOldEl = shadow.querySelector('.rc-price.strike-through');
      const priceNewEl = shadow.querySelector('.rc-price.strike-through + .rc-price');
      const priceOldOneTimeEl = shadow.querySelector('.rc-selection__onetime .strike-through');
      const priceOneTimeEl = shadow.querySelector('.rc-selection__onetime .rc-price');

      if (!priceOldEl && !priceNewEl && !priceOneTimeEl) return;
      
      // Update One-Time texts inside widget
      if (priceOldOneTimeEl) {
        priceOldOneTimeEl.textContent = quantity > 1 ? `${getCurrencyTitle()}${oldPrice}` : '';
      }
      priceOldEl.textContent = `${getCurrencyTitle()}${oldPrice}`;
      priceOneTimeEl.textContent = `${getCurrencyTitle()}${oneTimePrice}`;

      // --- 1. PREIS PARSEN (Schweiz/DE kompatibel) ---
      // Wir holen den Basispreis sauber aus den Rohdaten, statt ihn aus dem HTML zu kratzen
      const unitPriceCents = window.myProductData?.price || 0;
      const totalBasePrice = (unitPriceCents / 100) * quantity;

      // Parse den aktuellen "Einmalkauf-Preis" (String) sicher in eine Zahl
      // Entfernt Tausender-Trennzeichen und sorgt für korrekten Dezimalpunkt
      let currentOneTimePrice;
      if (typeof oneTimePrice === 'string') {
        // Entfernt alles außer Zahlen, Punkt und Komma
        let cleanString = oneTimePrice.replace(/[^0-9.,]/g, '');
        // Wenn Komma als Dezimaltrenner (DE), dann ersetzen. Sonst (CH/US) lassen.
        if (cleanString.includes(',') && !cleanString.includes('.')) { 
             cleanString = cleanString.replace(',', '.');
        } else if (cleanString.includes(',') && cleanString.includes('.')) {
             // Fall: 1.200,50 -> Komma ist Dezimal
             if (cleanString.lastIndexOf(',') > cleanString.lastIndexOf('.')) {
                 cleanString = cleanString.replace(/\./g, '').replace(',', '.');
             } else {
                 // Fall: 1,200.50 -> Punkt ist Dezimal
                 cleanString = cleanString.replace(/,/g, '');
             }
        }
        currentOneTimePrice = parseFloat(cleanString);
      } else {
        currentOneTimePrice = totalBasePrice;
      }
      
      if (isNaN(currentOneTimePrice)) currentOneTimePrice = totalBasePrice;

      // --- 2. SHOPIFY RECHENLOGIK ANWENDEN ---
      // Differenz = Dein Mengenrabatt (z.B. 10,80€)
      const bundleDiscountAmount = Math.max(0, totalBasePrice - currentOneTimePrice);

      // Erst Abo-Rabatt auf den VOLLEN Preis...
      const subscriptionFactor = 1 - (discountPercent / 100);
      const subTotalBase = totalBasePrice * subscriptionFactor;

      // ...dann Mengenrabatt abziehen
      const finalCalcPrice = subTotalBase - bundleDiscountAmount;
      const safeFinalPrice = Math.max(0, finalCalcPrice);
      const discountedPrice = bankersRound(safeFinalPrice);

      // --- 3. WIDGET UPDATE ---
      // Das Widget Label (z.B. "Subscribe & Save: 12.72") wird immer geupdated
      priceNewEl.textContent = `${getCurrencyTitle()}${formatNumberLocale(discountedPrice)}`;

      // --- 4. HAUPTPREIS UPDATE (Nur wenn Abo aktiv!) ---
      // Prüfen, ob das Abo-Radio-Button gecheckt ist
      const subRadio = shadow.querySelector('.rc-purchase-option__subscription rc-radio-icon');
      const isSubscriptionActive = subRadio?.hasAttribute('checked');

      if (isSubscriptionActive) {
          const priceEl = document.querySelector('.product-price_top .price');
          if (priceEl) {
              priceEl.textContent = `${getCurrencyTitle()}${formatNumberLocale(discountedPrice)}`;
          }
      }
    }


    /* old commented by johannes
    function updateRechargeWidgetVisualPrice(oldPrice, oneTimePrice, quantity) {
      const widget = document.querySelector('recharge-subscription-widget');
      if (!widget?.shadowRoot) return;

      const shadow = widget.shadowRoot;

      const priceOldEl = shadow.querySelector('.rc-price.strike-through');
      const priceNewEl = shadow.querySelector('.rc-price.strike-through + .rc-price');
      const priceOldOneTimeEl = shadow.querySelector('.rc-selection__onetime .strike-through');
      const priceOneTimeEl = shadow.querySelector('.rc-selection__onetime .rc-price');

      if (!priceOldEl && !priceNewEl && !priceOneTimeEl) return;
      
      if (priceOldOneTimeEl) {
        priceOldOneTimeEl.textContent = quantity > 1 ? `${getCurrencyTitle()}${oldPrice}` : '';
      }
      
      priceOldEl.textContent = `${getCurrencyTitle()}${oldPrice}`;
      priceOneTimeEl.textContent = `${getCurrencyTitle()}${oneTimePrice}`;

      // --- 🧮 Apply discount ---
      const oldPriceNum = parseFloat(oneTimePrice.replace(',', '.'));
      const discountedPrice = bankersRound(oldPriceNum * (1 - discountPercent / 100));

      priceNewEl.textContent = `${getCurrencyTitle()}${formatNumberLocale(discountedPrice)}`;

      // Change price
      const priceEl = document.querySelector('.product-price_top .price');
      priceEl.textContent = `${getCurrencyTitle()}${formatNumberLocale(discountedPrice)}`;
      
      console.log(`Recharge price updated: ${oneTimePrice} → ${discountedPrice} (${discountPercent}% off)`);
    }


    */

    function whenRechargeReady(callback) {
      const widget = document.querySelector('recharge-subscription-widget');
      if (!widget || !widget.shadowRoot) return false;

      function check() {
        const subscriptionInput = widget.shadowRoot.querySelector(
          '.rc-purchase-option__subscription input.rc-purchase-option__input'
        );
        if (subscriptionInput) {
          callback(widget);
          return true;
        }
        return false;
      }

      if (check()) return true;

      // Observe Shadow DOM until subscription input appears
      const observer = new MutationObserver(() => {
        if (check()) observer.disconnect();
      });

      observer.observe(widget.shadowRoot, { childList: true, subtree: true });
    }


    function initBlockScript() {
      observeRechargeMainStyles();
      observeRechargeBenefitsStyles();
      observeRechargeOneTimePurchaseStyles();

      const block = document.querySelector(`.${BLOCK_CLASS}`);
      if (!block) return;
  
      quantityInputs = Array.from(block.querySelectorAll('input[name="quantity-box"]'));

      const isSingleItem = !quantityInputs.length;
      const hasCompareAtPrice = !!window.myProductData?.compare_at_price;

      if (isSingleItem) {
        // Original price must always be shown even though there is no quantity selector
        if (hasCompareAtPrice) { updatePrice(1); }
        return
      };
  
      handleChange = (event) => {
        const selectedQuantity = parseInt(event.target.value, 10);

        let discount = 0;
        let weight = 0;

        if (event.target.hasAttribute('data-discount-percentage')) {
          discount = event.target.getAttribute('data-discount-percentage');
        }

        if (event.target.hasAttribute('data-product-weight')) {
          weight = event.target.getAttribute('data-product-weight');
        }
        
        updatePrice(selectedQuantity);
        // updatePricePerKg(discount, weight);
      };
  
      quantityInputs.forEach((input) => {
        input.addEventListener('change', handleChange);
      });
      
      const defaultQuantity = window.myProductData.default_selected_quantity;

      const defaultProductWeight = parseInt(
        block.querySelector('input[name="quantity-box"]:checked')?.getAttribute('data-product-weight') || '1',
        10
      );
      
      updatePrice(defaultQuantity);

      whenRechargeReady(() => {
        const input = quantityInputs.find(
          el => parseInt(el.value, 10) === defaultQuantity
        );

        if (!input) return;

        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));

        // Optional: sync Shopify main quantity input
        const shopifyQty = document.querySelector('input[name="quantity"]');
        if (shopifyQty) {
          shopifyQty.value = defaultQuantity;
          shopifyQty.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      

      // updatePricePerKg(0, defaultProductWeight);
    }
  
    function destroyBlockScript() {
      quantityInputs.forEach((input) => {
        input.removeEventListener('change', handleChange);
      });
      quantityInputs = [];
      handleChange = null;
    }
  
    document.addEventListener('DOMContentLoaded', initBlockScript);
  
    document.addEventListener('shopify:section:load', (event) => {
      console.log('section load');
      if (event.target.querySelector(`.${BLOCK_CLASS}`)) {
        initBlockScript();
      }
    });
  
    document.addEventListener('shopify:section:unload', (event) => {
      console.log('section unload');
      if (event.target.querySelector(`.${BLOCK_CLASS}`)) {
        destroyBlockScript();
      }
    });
  })();
